// @flow

import React, { type Node } from 'react';

import { ProviderInformation } from './provider-information';
import { Separator, SectionTitle, SectionSubtitle } from '../../../../../commons/atoms';

export function PagoefectivoInstructions(): Node {
  return (
    <section>
      <SectionTitle>Instrucciones de pago</SectionTitle>
      <Separator size="0.8em" />
      <SectionSubtitle>Elige abajo tu opción favorita y vea las instrucciones:</SectionSubtitle>
      <Separator size="1em" />
      <ProviderInformation />
    </section>
  );
}
